
import { Vue, Component, Prop } from 'vue-property-decorator'
  @Component
export default class HistorySign extends Vue {
    @Prop() signHistoryList: any

    pointStatus: any = {
      1: '未开始',
      2: '进行中',
      3: '已完成',
      4: '已跳过'
    }
}
